module.exports = __webpack_public_path__ + "img/hydro.ac58a4c5.gif";